import { Path } from "react-konva";

export function SubitemsIcon({ x = 0, y = 0 }: { x?: number; y?: number }) {
  return (
    <Path
      data="M2.76367 0C3.01771 0.000237649 3.22353 0.206871 3.22363 0.460938C3.22363 0.715095 3.01777 0.921637 2.76367 0.921875H2.07324V4.60449H7.29102V3.83789C7.29119 3.41431 7.63502 3.07049 8.05859 3.07031H12.8174C13.2408 3.07064 13.5838 3.4144 13.584 3.83789V6.29395C13.5838 6.71741 13.2408 7.0612 12.8174 7.06152H8.05859C7.63503 7.06134 7.29123 6.7175 7.29102 6.29395V5.52637H2.07324V10.7441H7.29102V9.97656C7.29141 9.55316 7.63515 9.20916 8.05859 9.20898H12.8174C13.2407 9.20931 13.5836 9.55325 13.584 9.97656V12.4326C13.584 12.8563 13.2409 13.1999 12.8174 13.2002H8.05859C7.6349 13.2 7.29102 12.8563 7.29102 12.4326V11.665H1.6123C1.35803 11.665 1.15142 11.4593 1.15137 11.2051V0.921875H0.460938C0.206724 0.921768 0 0.715176 0 0.460938C0.000107185 0.20679 0.20679 0.000107185 0.460938 0H2.76367ZM8.21289 12.2793H12.6631V10.1309H8.21289V12.2793ZM8.21289 6.14062H12.6631V3.99219H8.21289V6.14062Z"
      fill="#7F869B"
      x={x}
      y={y}
    />
  );
}
